import type { BenefitsConfig } from '#types/config/components/loyalty/benefits'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    heading: 'mb-4 title-3',
  },
  iconWidth: 32,
} satisfies RecursivePartial<BenefitsConfig>
